import { authenticatedApi, ApiError, API_BASE_URL } from './apiUtils';

export const managerHistoryApi = {
  /**
   * Create a new manager history record
   * POST /api/manager-history
   */
  createManagerHistory: async ({ managerId, type, projectId, teamId, businessUnitId, clusterId, startDate, endDate }) => {
    try {
      return await authenticatedApi.post(`${API_BASE_URL}/manager-history`, {
        managerId,
        type,
        projectId,
        teamId,
        businessUnitId,
        clusterId,
        startDate,
        endDate
      });
    } catch (error) {
      if (error.status === 400) {
        throw new ApiError(error.data?.error || 'Invalid data', 400);
      }
      if (error.status === 409) {
        throw new ApiError(error.data?.error || 'Conflict with existing record', 409, error.data);
      }
      throw new ApiError('Failed to create manager history record', error.status || 500);
    }
  },

  /**
   * Delete a manager history record
   * DELETE /api/manager-history/:id
   */
  deleteManagerHistory: async (historyId) => {
    try {
      return await authenticatedApi.delete(`${API_BASE_URL}/manager-history/${historyId}`);
    } catch (error) {
      if (error.status === 403) {
        throw new ApiError(error.data?.error || 'No permission to delete this record', 403);
      }
      if (error.status === 404) {
        throw new ApiError('Record not found', 404);
      }
      throw new ApiError('Failed to delete manager history record', error.status || 500);
    }
  },

  /**
   * Replace the manager on a history record
   * PATCH /api/manager-history/:id/manager
   */
  updateManagerHistoryManager: async (historyId, managerId) => {
    try {
      return await authenticatedApi.patch(`${API_BASE_URL}/manager-history/${historyId}/manager`, { managerId });
    } catch (error) {
      if (error.status === 400) {
        throw new ApiError(error.data?.error || 'Invalid manager data', 400);
      }
      if (error.status === 404) {
        throw new ApiError('Record not found', 404);
      }
      throw new ApiError('Failed to update manager', error.status || 500);
    }
  },

  /**
   * Update dates on a history record
   * PATCH /api/manager-history/:id/dates
   */
  updateManagerHistoryDates: async (historyId, { startDate, endDate }) => {
    try {
      return await authenticatedApi.patch(`${API_BASE_URL}/manager-history/${historyId}/dates`, { startDate, endDate });
    } catch (error) {
      if (error.status === 400) {
        throw new ApiError(error.data?.error || 'Invalid date data', 400);
      }
      if (error.status === 404) {
        throw new ApiError('Record not found', 404);
      }
      if (error.status === 409) {
        throw new ApiError(error.data?.error || 'Date conflict with existing record', 409, error.data);
      }
      throw new ApiError('Failed to update dates', error.status || 500);
    }
  },
};
